import React, { useEffect, useState } from 'react';
import './sideBarMobile.scss';
import { Collapse, Drawer } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { v4 as uuidV4 } from 'uuid';
import { useHistory } from 'react-router';
import ModalWithAction from 'app/shared/components/common/modal/modal-with-Action';
import { getAttributUrl } from 'app/shared/util/methode-util';
import { useDispatch, useSelector } from 'react-redux';
import { getClaimsList } from 'app/modules/claim/service/store/selectors';
import { getSubscriptionsList } from 'app/modules/contract/service/store/selectors';
import { getModalInformationButton } from 'app/modules/cms/service/store/selectors';

const SideBar = props => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [selectedMenuIndex, setSelectedMenuIndex] = useState(-1);
  const [openModal, setOpenModal] = useState(false);
  const subscriptionsList: any = useSelector(getSubscriptionsList);
  const [open, setOpen] = React.useState(false);
  const infoLegalLabel = props.sideNavCmsData?.items?.find(item => item.code === '9')?.label;
  const handleClick = () => {
    setOpen(!open);
  };
const modalInformation: any = useSelector(getModalInformationButton)
  const getTotalNbClaims = () => {
    let totalNbClaims = 0;
    if (subscriptionsList) {
      for (let i = 0; i < subscriptionsList?.length; i++) {
        totalNbClaims += subscriptionsList[i]?.nbClaims;
      }
    }
    return totalNbClaims;
  };
  const totalNbClaims = getTotalNbClaims();

  const handleClickMenuItem = (item, index) => {
    if (item.type === 'collapse') {
      if (selectedMenuIndex === index) {
        setSelectedMenuIndex(-1);
      } else {
        setSelectedMenuIndex(index);
      }
    } else {
      props.setMenuClose(!props.menuOpen);
      setSelectedMenuIndex(-1);
      if (!item.documentUrl && item.link) {
        history.push(item.link);
      }
    }
  };

  const syncData = (val, attributeKey) => {
    if (val?.code === 1) {
      if (subscriptionsList?.length === 0) {
        return '';
      } else {
        const resulta = props.sideNavCmsData?.items?.find(v => v.code === val?.code?.toString());
        if (resulta) {
          switch (attributeKey) {
            case 'LABEL':
              return subscriptionsList?.length > 1 ? resulta?.label : resulta?.singularlabel;
            case 'ICON':
              return resulta.icon;
            default:
              return '';
          }
        }
      }
    }
    if (val.code !== 8) {
      const resulta = props.sideNavCmsData?.items?.find(v => v.code === val?.code?.toString());
      if (resulta) {
        switch (attributeKey) {
          case 'LABEL':
            return resulta.label;
          case 'ICON':
            return resulta.icon;
          default:
            return '';
        }
      }
    } else {
      if (totalNbClaims === 0) {
        return '';
      } else {
        const resulta = props.sideNavCmsData?.items?.find(v => v.code === val?.code?.toString());
        if (resulta) {
          switch (attributeKey) {
            case 'LABEL':
              return totalNbClaims !== 1
                ? resulta.label.replace('{Mes/mon}', 'Mes').replace('{s}', 's')
                : resulta.label.replace('{Mes/mon}', 'Mon').replace('{s}', '');
            case 'ICON':
              return resulta.icon;
            default:
              return '';
          }
        }
      }
    }
  };
  const handleOpen = () => {
    setOpenModal(true);
  };
  const handleLogOut = () => {
    setOpenModal(true);
    if (!openModal) {
      props.setMenuClose(!openModal);
    }
  };
  const handleDrawerClose = () => {
    props.setMenuClose(!props.menuOpen);
  };
  const menuRedirect = (items: any) => {
    const menuItems = items?.filter(
      (item: any) => item?.code?.toString() === '1' || item?.code?.toString() === '8' || item?.code?.toString() === '7'
    );

    return (
      <>
        {menuItems?.map(item => {
          const label = syncData(item, 'LABEL')
          if (label?.length > 0) {
            return (
              <React.Fragment key={uuidV4()}>
                <p
                  className={'pt-3'}
                  onClick={() => {
                    history.push(item.url);
                    setOpenModal(false);
                    props.setMenuClose(!props.menuOpen);
                  }}
                >
                  <img src={syncData(item, 'ICON')?.url} alt={item.label} />
                  {label}
                </p>
              </React.Fragment>
            )
          }
        })}
      </>
    );
  };
  const legalInfos = (items: any) => {
    const menuItems = items?.filter(
      item =>
        item?.code.toString() === '2' || item?.code.toString() === '3' || item?.code.toString() === '4' || item?.code.toString() === '6'
    );
console.log(menuItems)
    return (
      <>
     { menuItems?.length > 0
 && <><p onClick={handleClick} className={'pt-3'}>
          <img />
          {infoLegalLabel}
          {open ? <ExpandLess /> : <ExpandMore />}
        </p>
        <Collapse in={open} timeout="auto" unmountOnExit>
          {menuItems?.map(item => (
            <p
              key={uuidV4()}
              className={'pt-3 pl-2'}
              onClick={() => {
                history.push({
                  pathname: '/document',
                  state: { documentName: getAttributUrl(item.url, 'documentName'), default: getAttributUrl(item.url, 'default') },
                });
                props.setMenuClose(!props.menuOpen);
              }}
            >
              <img src={syncData(item, 'ICON')?.url} alt={item.label} />
              {syncData(item, 'LABEL')}
            </p>
          ))}
        </Collapse>
        </>}
      </>

    );
  };
  const deconnecter = (items: any) => {
    const menuItems = items?.filter(item => item?.code === 0 || item?.code === 5);

    return (
      <>
        {menuItems?.map(item => (
          <p
            key={uuidV4()}
            className={'pt-3'}
            onClick={() => {
              item?.code?.toString() === '0' ? handleLogOut() : props.didomiObject.preferences.show();
              props.setMenuClose(!props.menuOpen);
            }}
          >
            <img src={syncData(item, 'ICON')?.url} alt={item.label} />
            {syncData(item, 'LABEL')}
          </p>
        ))}
      </>
    );
  };
  return (
    <>
      <Drawer anchor={'left'} open={props.menuOpen} onClose={handleDrawerClose}>
        <div className="menu-spb">
          <div className="list-menu">
            {menuRedirect(props.items)}
            {legalInfos(props.items)}
            {deconnecter(props.items)}
          </div>
          <div className='menu-spb-footer'>
            <div className='footer-logo'>
              <img className='footer-img' src={props.sideNavCmsData?.logoicon?.url} alt="SPB logo" />
            </div>
            {props.sideNavCmsData?.version_label && (
              <div className="menu-spb-footer-version">
                {props.sideNavCmsData?.version_label} {process.env.REACT_APP_VERSION.replace('-SNAPSHOT', '')}{' '}
              </div>
            )}
          </div>
        </div>
      </Drawer>
      <ModalWithAction
        showModal={openModal}
        setShowModel={setOpenModal}
        textBody="Voulez-vous vraiment vous déconnecter ?"
        action={() => {
          setOpenModal(false);
          history.push('/logout');
        }}
        btnActionLabel={modalInformation?.CONFIRMED_button}
        btnCloseLabel={modalInformation?.CANCEL_button}

      />
    </>
  );
};
export default SideBar;
